import {Component, Input, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {Router} from '@angular/router';
import {NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.css']
})
export class InputDialogComponent extends BaseDialog<String> implements OnInit {

  @Input()
  description: string;

  inputValue: string;

  constructor(dialogRef: NbDialogRef<String>, route: Router) {
    super(dialogRef, route);
  }

  ngOnInit() {
  }

}
